module.exports = __webpack_public_path__ + "img/9.3c877eb5.jpg";